import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Container,
    Content,
    Title,
    ButtonArea,
} from './styles';

export const Header = () => {
  const history = useNavigate();
  const path = useLocation();
  return (
      <Container>
          <Content>
            <Title>
                <h2>Fellas</h2>
            </Title>
            <ButtonArea>
                <button onClick={()=>history("/home")} style={{"textDecoration": path.pathname == '/home' ? 'underline' : 'none' }} >
                    Home
                </button>
                <button onClick={()=>history("/track")} style={{"textDecoration": path.pathname == '/track' ? 'underline' : 'none' }} >Track</button>
                <button onClick={()=>history("/profile")} style={{"textDecoration": path.pathname == '/profile' ? 'underline' : 'none' }} >Profile</button>
            </ButtonArea>
          </Content>
      </Container>
  )
};
